import AlertComponent from './dg-alert.vue';

let Alert = {}

// Vue暴露了一个install方法，用于自定义插件
Alert.install = function (Vue) {
    // 创建一个子类
    let AlertConstructor = Vue.extend(AlertComponent);
    // 实例化这个子类
    let instance = new AlertConstructor();
    // 创建一个div元素，并把实例挂载到div元素上
    instance.$mount(document.createElement('div'));
    // 将el插入到body元素中
    document.body.appendChild(instance.$el);
    // 添加实例方法
    // alert插件的实例方法：只接收提示信息msg
    // Vue.prototype.$dgAlert = msg => {
    //     instance.type = 'alert';
    //     instance.msg = msg;
    //     instance.isShow = true;
    // };
    // confirm插件的实例方法，可以接收三个参数
    // msg：提示信息
    // success：点击确定执行的函数
    // cancel：点击取消执行的函数
    Vue.prototype.$dgAlert = (msg, { callback, cancel, confirmButtonText = "确定", cancelButtonText = "取消", showCancelButton = false, type = null, center = true, dislocationBtn = false }) => {
        instance.type = type;
        instance.msg = msg;
        instance.confirmButtonText = confirmButtonText;
        instance.cancelButtonText = cancelButtonText;
        instance.showCancelButton = showCancelButton;
        instance.center = center;
        instance.isShow = true;
        instance.dislocationBtn = dislocationBtn;
        if (typeof callback !== 'undefined') {
            instance.callback = callback;
        }
        if (typeof cancel !== 'undefined') {
            instance.cancel = cancel
        }
    }
    Vue.prototype.$dgAlertClose = () => {
        instance.isShow = false;
    }
}

export default Alert;